import { Injectable, Injector } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { EMPLOYEE_AUTH_SERVICE_IMPL } from 'pm-src/services/employee-auth/i-employee-auth.service';

@Injectable()
export class EmployeeInterceptor implements HttpInterceptor {
    constructor(private _injector: Injector) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.handle(request, next));
    }

    private async handle(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Promise<HttpEvent<any>> {
        const employeeAuthService = await this._injector.get(EMPLOYEE_AUTH_SERVICE_IMPL);
        const currentEmployee = employeeAuthService.currentEmployee;
        const hasActiveEmployee = employeeAuthService.hasActiveEmployee();
        if (currentEmployee && currentEmployee.authToken && hasActiveEmployee) {
            request = request.clone({
                setHeaders: {
                    EmployeeToken: `${currentEmployee.authToken}`,
                },
            });
        }
        return next.handle(request).toPromise();
    }
}
